import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import css from './AddShipper.module.css';
import { Modal, Select, MenuItem, MuiThemeProvider, FormLabel, FormGroup } from '@material-ui/core';
import cs from 'classnames';
import * as Constants from 'constants/Constants';

import {
    withStyles,
    Paper,
    Typography,
    IconButton,
    FormControl,
    InputLabel,
    FilledInput,
    Button,
    FormHelperText,
    TextField
} from '@material-ui/core';
import IdentifierSearch from './IdentifierSearch/IdentifierSearch';
import ShipperCodeSearch from './ShipperSearch/ShipperCodeSearch';
import {
    PRIMARY_BUTTON_DEFAULT_NEGATIVE_THEME,
    PRIMARY_BUTTON_DEFAULT_POSITIVE_THEME
} from 'components/UI/Button/ButtonMuiTheme';
import {
    isBlank,
    isNotEmptyList,
    isNotEmptyObject,
    isEmptyObject,
    isEmptyList,
    isNotBlank
} from 'components/Common/Utils/StringUtils';
import {
    addNewShipper,
    clearShipmentIdentifiers,
    getShipmentIdentifiers,
    sendSelectedDataSource,
    saveShipperConfig
} from 'components/TrustCenter/store/actions';
import { PrimarySwitch } from 'theme/CommonTheme';
import { SWITCH_LABEL } from 'components/TrustCenter/TrustCenterMuiTheme';
import { MACROPOINT, MACROPOINT_NAME } from 'components/TrustCenter/store/actions/types';
import { validateField } from 'components/Common/Utils/BaseUtils';

const styles = (theme) => ({
    paper: {
        position: 'absolute',
        borderRadius: 5,
        width: '80%',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: '10px 20px',
        outline: 'none'
    }
});

function getModalStyle() {
    const top = 16;
    const left = 10;

    return {
        top: `${top}%`,
        left: `${left}%`
    };
}

const AddShipper = (props) => {
    const {
        classes,
        dataSource,
        showAddShipperModel,
        sendSelectedDataSource,
        addNewShipper,
        identifiers,
        closeAddShipperModel,
        newShipperAgreement,
        groupName,
        agreements,
        editedAgreements,
        session,
        selectedConnection,
        selectedProvider
    } = props;

    const fieldObject = {
        datasource: {},
        shipperCode: {},
        shipmentIdentifier: [],
        shipperConfig: {}
    };

    const isMacropointProvider = () => {
        return isEmptyObject(agreements)
            ? selectedProvider?.name === MACROPOINT
            : selectedConnection?.name == MACROPOINT;
    };

    const errorFieldObject = {
        datasource: {
            isInvalid: false,
            message: ''
        },
        shipperCode: {
            isInvalid: false,
            message: ''
        },
        shipmentIdentifier: {
            isInvalid: false,
            message: ''
        },
        shipperConfig: {
            isInvalid: true,
            message: ''
        }
    };

    const [userAddedShippers, setUserAddedShippers] = useState([
        JSON.parse(JSON.stringify(fieldObject))
    ]);

    const [modalStyle] = React.useState(getModalStyle);

    const [errorFieldList, setErrorFieldList] = useState([{ ...errorFieldObject }]);

    const [disableShipperCodeReset, setDisableShipperCodeReset] = useState(false);

    const [allShipperDatasource, setAllShipperDatasource] = useState(new Map());

    useEffect(() => {
        if (disableShipperCodeReset) {
            setDisableShipperCodeReset(false);
        }
    }, [userAddedShippers]);

    const handleRemoveShipper = (index) => {
        if (userAddedShippers.length > 1) {
            setDisableShipperCodeReset(true);

            let tempAllShipperSelected = allShipperDatasource;

            let modifiedAllShipper = new Map(tempAllShipperSelected);

            if (
                modifiedAllShipper.has(userAddedShippers[index].datasource.id) &&
                modifiedAllShipper.get(userAddedShippers[index].datasource.id) === index
            ) {
                modifiedAllShipper.delete(userAddedShippers[index].datasource.id);
            }
            tempAllShipperSelected.forEach((valueIndex, key, map) => {
                if (valueIndex > index) {
                    modifiedAllShipper.set(key, valueIndex - 1);
                }
            });
            setAllShipperDatasource(new Map(modifiedAllShipper));

            let shipperList = [...userAddedShippers];
            shipperList.splice(index, 1);

            let tempErrorFieldList = [...errorFieldList];
            tempErrorFieldList.splice(index, 1);

            tempErrorFieldList = validateAllDataSource(
                shipperList,
                tempErrorFieldList,
                modifiedAllShipper
            );

            setUserAddedShippers([...shipperList]);
            setErrorFieldList([...tempErrorFieldList]);
        }
    };

    const validateAllDataSource = (
        shipperList,
        errorFieldList,
        allShipperDatasource,
        currentIndex
    ) => {
        shipperList.forEach((shipper, index) => {
            if (isNotEmptyObject(shipper.datasource)) {
                if (!allShipperDatasource.has(shipper.datasource.id)) {
                    errorFieldList[index].datasource.isInvalid = false;
                    errorFieldList[index].datasource.message = '';
                } else {
                    if (index !== allShipperDatasource.get(shipper.datasource.id)) {
                        errorFieldList[index].datasource.isInvalid = true;
                        errorFieldList[index].datasource.message = 'All shippers selected';
                    }
                }
            }
        });
        return errorFieldList;
    };

    const createNewShipper = () => {
        let tempUserAddedShippers = [...userAddedShippers];
        tempUserAddedShippers.push(JSON.parse(JSON.stringify(fieldObject)));
        setUserAddedShippers([...tempUserAddedShippers]);

        let tempErrorFieldList = [...errorFieldList];
        tempErrorFieldList.push({ ...errorFieldObject });
        setErrorFieldList([...tempErrorFieldList]);
    };

    const getSelectedDatasource = (shipper) => {
        if (shipper.datasource !== undefined && shipper.datasource.id !== undefined) {
            return shipper.datasource.id.toString();
        }
        return '';
    };

    const getSelectedDatasourceInt = (shipper) => {
        if (shipper.datasource !== undefined && shipper.datasource.id !== undefined) {
            return shipper.datasource.id;
        }
        return Constants.BLANK_DATASOURCE_ID;
    };

    const handleDataSourceChange = (index) => (event) => {
        let selectedSource = dataSource.find((data) => data.id === event.target.value);
        if (selectedSource === undefined) {
            selectedSource = {};
        }

        clearallSelected(index);

        sendSelectedDataSource(selectedSource);
        let tempUserAddedShippers = [...userAddedShippers];
        tempUserAddedShippers[index].datasource = selectedSource;
        setUserAddedShippers([...tempUserAddedShippers]);

        validateDatasource(index)(event);
    };

    const clearallSelected = (index) => {
        let tempAllShipperSelected = allShipperDatasource;
        let datasourceId = userAddedShippers[index].datasource.id;
        if (
            tempAllShipperSelected.has(datasourceId) &&
            tempAllShipperSelected.get(datasourceId) === index
        ) {
            tempAllShipperSelected.delete(datasourceId);
            setAllShipperDatasource(new Map(tempAllShipperSelected));
        }
    };

    const handleShipperCodeChange = (shipperCode, index) => {
        let tempUserAddedShippers = [...userAddedShippers];
        tempUserAddedShippers[index].shipperCode = shipperCode;
        setUserAddedShippers([...tempUserAddedShippers]);
        validateShipperCode(shipperCode, index);
    };

    const handleAllShipperCodeChange = (shipper, index) => (event) => {
        let tempAllShipperSelected = new Map(allShipperDatasource);
        let selectedDataSource = getSelectedDatasourceInt(shipper);
        if (event.target.checked) {
            tempAllShipperSelected.set(selectedDataSource, index);
        } else {
            tempAllShipperSelected.delete(selectedDataSource);
        }
        setAllShipperDatasource(tempAllShipperSelected);
        let tempErrorFieldList = validateAllDataSource(
            userAddedShippers,
            errorFieldList,
            tempAllShipperSelected,
            index
        );
        setErrorFieldList([...tempErrorFieldList]);
    };

    const handleShipperIdentifiersChange = (identifiers, errorFields, index) => {
        let tempUserAddedShippers = [...userAddedShippers];
        tempUserAddedShippers[index].shipmentIdentifier = identifiers;
        setUserAddedShippers([...tempUserAddedShippers]);
        let tempErrorFieldList = [...errorFieldList];
        tempErrorFieldList[index].shipmentIdentifier = errorFields;
        setErrorFieldList([...tempErrorFieldList]);
    };

    const saveAgreementRequest = () => {
        let shipperAgreements = { ...newShipperAgreement };
        let currentGroupName = groupName;
        if (isBlank(groupName)) {
            currentGroupName = '';
        }
        userAddedShippers.forEach((userInput) => {
            let agreement = {};
            agreement.datasource = userInput.datasource;
            if (allShipperDatasource.has(userInput.datasource.id)) {
                agreement.name = Constants.SHIPPER_CODE_ALL_SHIPPER;
                agreement.shipper_code = Constants.SHIPPER_CODE_ALL_SHIPPER;
                agreement.shipment_identifier = userInput.shipmentIdentifier;
            } else {
                agreement.name = userInput.shipperCode.company_name;
                agreement.shipper_code = userInput.shipperCode.shipper_code;
                agreement.shipment_identifier = userInput.shipmentIdentifier;
            }
            if (Object.keys(shipperAgreements).length === 0) {
                shipperAgreements[currentGroupName] = [];
            }
            if (isMacropointProvider()) {
                const dataSourceId = userInput?.datasource?.id;
                let shipperConfig = {
                    ...userInput?.shipperConfig,
                    accountId: session?.accountUuid,
                    dataSourceId: dataSourceId?.toString(),
                    shipperCode: userInput?.shipperCode?.shipper_code
                };
                const updatedAgreement = {
                    ...agreement,
                    shipperConfig: shipperConfig
                };
                props.saveShipperConfig(shipperConfig, () => {
                    shipperAgreements[currentGroupName].push(updatedAgreement);
                    addNewShipper({ ...shipperAgreements });
                });
            } else {
                shipperAgreements[currentGroupName].push(agreement);
                addNewShipper({ ...shipperAgreements });
            }
        });

        handleClose();
    };

    const handleClose = () => {
        closeAddShipperModel();
        let blankField = { ...fieldObject };
        let tempUserAddedShippers = [...userAddedShippers];
        tempUserAddedShippers = [];
        tempUserAddedShippers.push(blankField);
        setAllShipperDatasource(new Map());
        setUserAddedShippers([...tempUserAddedShippers]);
        setErrorFieldList([JSON.parse(JSON.stringify(fieldObject))]);
    };

    const validateDatasource = (index) => (event) => {
        let tempErrorFieldList = [...errorFieldList];
        tempErrorFieldList[index] = { ...errorFieldObject };
        if (event.target.value === '') {
            tempErrorFieldList[index][event.target.name].isInvalid = true;
            tempErrorFieldList[index][event.target.name].message = 'Kindly select an Application';
        } else if (
            allShipperDatasource.has(parseInt(event.target.value)) ||
            isAllShipperAlreadySelectedInExistingAgreements(index)
        ) {
            tempErrorFieldList[index][event.target.name].isInvalid = true;
            tempErrorFieldList[index][event.target.name].message = 'All shippers already selected';
        } else {
            tempErrorFieldList[index][event.target.name].isInvalid = false;
            tempErrorFieldList[index][event.target.name].message = '';
        }
        setErrorFieldList([...tempErrorFieldList]);
    };

    const validateShipperCode = (shipperCode, index) => {
        let tempErrorFieldList = [...errorFieldList];
        if (!allShipperDatasource.has(userAddedShippers[index]?.datasource.id)) {
            if (Object.keys(shipperCode).length === 0) {
                tempErrorFieldList[index].shipperCode.isInvalid = true;
                // downshift itself handles this error
            } else if (isDuplicateExist(shipperCode, index)) {
                tempErrorFieldList[index].shipperCode.isInvalid = true;
                tempErrorFieldList[index].shipperCode.message =
                    'Shipper Code already exist!! Kindly remove or replace with other Shipper Code';
            } else {
                tempErrorFieldList[index].shipperCode.isInvalid = false;
                tempErrorFieldList[index].shipperCode.message = '';
            }
        } else {
            tempErrorFieldList[index].shipperCode.isInvalid = false;
            tempErrorFieldList[index].shipperCode.message = '';
        }
        setErrorFieldList([...tempErrorFieldList]);
    };

    const isDuplicateExist = (shipperCode, index) => {
        let datasource = userAddedShippers[index].datasource;
        let sameDatasourceShipperList = [];

        sameDatasourceShipperList = userAddedShippers
            .filter((input) => {
                return input.datasource.id === datasource.id;
            })
            .map((userInput) => {
                return userInput.shipperCode.shipper_code;
            });
        if (
            sameDatasourceShipperList.filter(
                (existingShipperCode) => existingShipperCode === shipperCode.shipper_code
            ).length > 1
        ) {
            return true;
        }
        if (isNotEmptyList(newShipperAgreement[groupName])) {
            sameDatasourceShipperList = newShipperAgreement[groupName]
                .filter((input) => {
                    return input.datasource.id === datasource.id;
                })
                .map((userInput) => {
                    return userInput.shipper_code;
                });
            if (sameDatasourceShipperList.includes(shipperCode.shipper_code)) {
                return true;
            }
        }
        let editedAgreementIdList = [];
        if (isNotEmptyList(editedAgreements[groupName])) {
            sameDatasourceShipperList = editedAgreements[groupName]
                .filter((editedAgreement) => {
                    editedAgreementIdList.push(editedAgreement.id);
                    return editedAgreement.datasource.id === datasource.id;
                })
                .map((userInput) => {
                    return userInput.shipper_code;
                });
            if (sameDatasourceShipperList.includes(shipperCode.shipper_code)) {
                return true;
            }
        }

        if (isNotEmptyList(agreements[groupName])) {
            sameDatasourceShipperList = agreements[groupName]
                .filter((savedAgreement) => {
                    return (
                        savedAgreement.datasource.id === datasource.id &&
                        !editedAgreementIdList.includes(savedAgreement.id)
                    );
                })
                .map((userInput) => {
                    return userInput.shipper_code;
                });
            if (sameDatasourceShipperList.includes(shipperCode.shipper_code)) {
                return true;
            }
        }
        return false;
    };

    const disableSelectAllShipper = (shipper, index) => {
        const selectedDataSource = getSelectedDatasourceInt(shipper);

        return (
            selectedDataSource === Constants.BLANK_DATASOURCE_ID ||
            (allShipperDatasource.has(selectedDataSource) &&
                allShipperDatasource.get(selectedDataSource) !== index) ||
            isNotEmptyObject(userAddedShippers[index].shipperCode) ||
            isAllShipperAlreadySelectedInExistingAgreements(index)
        );
    };

    const isSingleShipperSelected = (selectedDataSource) => {
        let matchingDatasourceShippers = userAddedShippers.filter((shipper) => {
            if (selectedDataSource === shipper.datasource.id) {
                if (
                    isNotEmptyObject(shipper.shipperCode) ||
                    isNotEmptyList(shipper.shipmentIdentifier)
                ) {
                    return true;
                }
            }
            return false;
        });

        if (isNotEmptyList(matchingDatasourceShippers)) {
            return true;
        }

        if (isNotEmptyList(newShipperAgreement[groupName])) {
            matchingDatasourceShippers = newShipperAgreement[groupName].filter((userInput) => {
                if (selectedDataSource === userInput.datasource.id) {
                    if (userInput.shipper_code !== Constants.SHIPPER_CODE_ALL_SHIPPER) {
                        return true;
                    }
                }
                return false;
            });
            if (isNotEmptyList(matchingDatasourceShippers)) {
                return true;
            }
        }

        let editedAgreementIdList = new Set();
        if (isNotEmptyList(editedAgreements[groupName])) {
            matchingDatasourceShippers = editedAgreements[groupName].filter((editedAgreement) => {
                editedAgreementIdList.add(editedAgreement.id);
                if (selectedDataSource === editedAgreement.datasource.id) {
                    if (editedAgreement.shipper_code !== Constants.SHIPPER_CODE_ALL_SHIPPER) {
                        return true;
                    }
                }
                return false;
            });
            if (isNotEmptyList(matchingDatasourceShippers)) {
                return true;
            }
        }

        if (isNotEmptyList(agreements[groupName])) {
            matchingDatasourceShippers = agreements[groupName].filter((savedAgreement) => {
                if (
                    selectedDataSource === savedAgreement.datasource.id &&
                    !editedAgreementIdList.has(savedAgreement.id)
                ) {
                    if (savedAgreement.shipper_code !== Constants.SHIPPER_CODE_ALL_SHIPPER) {
                        return true;
                    }
                }
                return false;
            });
            if (isNotEmptyList(matchingDatasourceShippers)) {
                return true;
            }
        }
        return false;
    };

    const isAllShipperAlreadySelected = (shipper, index) => {
        if (allShipperDatasource.has(getSelectedDatasourceInt(shipper))) {
            return true;
        }

        if (isAllShipperAlreadySelectedInExistingAgreements(index)) {
            return true;
        }
        return false;
    };

    const isAllShipperAlreadySelectedInExistingAgreements = (index) => {
        let datasource = userAddedShippers[index].datasource;
        let sameDatasourceShipperList = [];

        if (isNotEmptyList(newShipperAgreement[groupName])) {
            sameDatasourceShipperList = newShipperAgreement[groupName].filter((userInput) => {
                return (
                    userInput.datasource.id === datasource.id &&
                    userInput.shipper_code === Constants.SHIPPER_CODE_ALL_SHIPPER
                );
            });
            if (isNotEmptyList(sameDatasourceShipperList)) {
                return true;
            }
        }
        let editedAgreementIdList = [];
        if (isNotEmptyList(editedAgreements[groupName])) {
            sameDatasourceShipperList = editedAgreements[groupName].filter((editedAgreement) => {
                editedAgreementIdList.push(editedAgreement.id);
                return (
                    editedAgreement.datasource.id === datasource.id &&
                    editedAgreement.shipper_code === Constants.SHIPPER_CODE_ALL_SHIPPER
                );
            });
            if (isNotEmptyList(sameDatasourceShipperList)) {
                return true;
            }
        }

        if (isNotEmptyList(agreements[groupName])) {
            sameDatasourceShipperList = agreements[groupName].filter((savedAgreement) => {
                return (
                    savedAgreement.datasource.id === datasource.id &&
                    !editedAgreementIdList.includes(savedAgreement.id) &&
                    savedAgreement.shipper_code === Constants.SHIPPER_CODE_ALL_SHIPPER
                );
            });
            if (isNotEmptyList(sameDatasourceShipperList)) {
                return true;
            }
        }
        return false;
    };

    const isPremiumGroup = () => {
        return (
            isNotBlank(groupName) &&
            Constants.RESERVED_GROUPNAMES.includes(groupName.toUpperCase()) &&
            !isMacropointProvider()
        );
    };

    const disableSave = () => {
        let inValid = false;
        userAddedShippers.forEach((userInput, index) => {
            if (isEmptyObject(userInput.datasource)) {
                inValid = true;
            }
            if (!allShipperDatasource.has(userInput?.datasource.id)) {
                if (isEmptyObject(userInput.shipperCode)) {
                    inValid = true;
                }
                if (isMacropointProvider() && isBlank(userInput?.shipperConfig?.macropointID)) {
                    inValid = true;
                }
                if (
                    isNotEmptyList(identifiers.get(userInput?.datasource.id)) &&
                    isEmptyList(userInput.shipmentIdentifier)
                ) {
                    inValid = true;
                }
            }

            if (
                errorFieldList[index]?.datasource?.isInvalid ||
                errorFieldList[index]?.shipperCode?.isInvalid ||
                errorFieldList[index]?.shipmentIdentifier?.isInvalid
            ) {
                inValid = true;
            }
            if (isMacropointProvider() && errorFieldList[index]?.shipperConfig?.isInvalid) {
                inValid = true;
            }
        });

        return inValid;
    };

    const handleMacropointIdChange = (event, index) => {
        const { name, value } = event?.target ?? {};
        const tempUserAddedShippers = [...userAddedShippers];
        const tempErrorFieldList = [...errorFieldList];
        if (name === MACROPOINT_NAME) {
            const result = validateField(name, value);
            tempErrorFieldList[index]['shipperConfig'] = { ...result };
            setErrorFieldList([...tempErrorFieldList]);
            if (tempUserAddedShippers[index]) {
                const updatedShipper = {
                    ...tempUserAddedShippers[index],
                    shipperConfig: {
                        macropointID: value
                    }
                };
                tempUserAddedShippers[index] = updatedShipper;
            }
            setUserAddedShippers(tempUserAddedShippers);
        }
    };

    return (
        <div className="full-width">
            <Modal open={showAddShipperModel}>
                <Paper style={modalStyle} className={classes.paper}>
                    <Typography variant="h6" id="modal-title">
                        Add Shippers
                    </Typography>
                    <div className={css.viewableRegion}>
                        {userAddedShippers.map((shipper, index) => {
                            return (
                                <div className="row justify-content-around" key={index}>
                                    <div className="col-sm-3">
                                        <FormControl
                                            className={'full-width'}
                                            margin="normal"
                                            error={errorFieldList[index].datasource.isInvalid}
                                        >
                                            <InputLabel
                                                className={css.applicationInput}
                                                htmlFor="Type"
                                            >
                                                Application Name
                                            </InputLabel>
                                            <Select
                                                id={'datasource' + index}
                                                value={getSelectedDatasource(shipper)}
                                                name="datasource"
                                                onChange={handleDataSourceChange(index)}
                                                variant="standard"
                                                error={errorFieldList[index].datasource.isInvalid}
                                                onBlur={(event) => validateDatasource(index)(event)}
                                                input={
                                                    <FilledInput
                                                        name="datasourceId"
                                                        id="datasourceId"
                                                    />
                                                }
                                            >
                                                <MenuItem value="">
                                                    <em>None</em>
                                                </MenuItem>
                                                {dataSource.map((data, index) => {
                                                    return (
                                                        <MenuItem value={data.id} key={index}>
                                                            {data.name} - {data.type}
                                                        </MenuItem>
                                                    );
                                                })}
                                            </Select>
                                            <FormHelperText>
                                                {errorFieldList[index].datasource.message}
                                            </FormHelperText>
                                        </FormControl>
                                    </div>
                                    {isPremiumGroup() ? (
                                        <div className="col-sm-1">
                                            <FormControl component="fieldset" margin="normal">
                                                <MuiThemeProvider theme={SWITCH_LABEL}>
                                                    <FormLabel component="legend">
                                                        All Shippers
                                                    </FormLabel>
                                                </MuiThemeProvider>
                                                <FormGroup>
                                                    <PrimarySwitch
                                                        disabled={disableSelectAllShipper(
                                                            shipper,
                                                            index
                                                        )}
                                                        checked={
                                                            allShipperDatasource.has(
                                                                getSelectedDatasourceInt(shipper)
                                                            ) &&
                                                            allShipperDatasource.get(
                                                                getSelectedDatasourceInt(shipper)
                                                            ) === index
                                                        }
                                                        onChange={(event) =>
                                                            handleAllShipperCodeChange(
                                                                shipper,
                                                                index
                                                            )(event)
                                                        }
                                                    ></PrimarySwitch>
                                                </FormGroup>
                                            </FormControl>
                                        </div>
                                    ) : null}
                                    <div className="col-sm-3">
                                        <ShipperCodeSearch
                                            index={index}
                                            modal={true}
                                            allSelected={isAllShipperAlreadySelected(
                                                shipper,
                                                index
                                            )}
                                            disableShipperCodeReset={disableShipperCodeReset}
                                            selectedDataSource={getSelectedDatasource(shipper)}
                                            shipperCode={shipper.shipperCode}
                                            sendSelectedShipperCode={handleShipperCodeChange}
                                            variant="filled"
                                            customError={errorFieldList[index].shipperCode.message}
                                            userAddedShippers={userAddedShippers}
                                            isPremiumGroup={isPremiumGroup}
                                        />
                                    </div>
                                    <div
                                        className={
                                            isPremiumGroup() || isMacropointProvider()
                                                ? 'col-sm-3'
                                                : 'col-sm-4'
                                        }
                                    >
                                        <IdentifierSearch
                                            index={index}
                                            variant="filled"
                                            modal={true}
                                            sendSelectedIdentifiers={handleShipperIdentifiersChange}
                                            userAddedShipmentIdentifiers={
                                                shipper?.shipmentIdentifier
                                            }
                                            selectedDatasource={shipper?.datasource}
                                            allSelected={isAllShipperAlreadySelected(
                                                shipper,
                                                index
                                            )}
                                            groupName={groupName}
                                        />
                                    </div>
                                    {isMacropointProvider() ? (
                                        <div className="col-sm-3">
                                            <TextField
                                                fullWidth
                                                name="macropointId"
                                                label="Macropoint Id"
                                                id="macropoint_id"
                                                margin="normal"
                                                variant="filled"
                                                required
                                                value={shipper?.shipperConfig?.macropointID}
                                                error={
                                                    isNotBlank(
                                                        shipper?.shipperConfig?.macropointID
                                                    ) &&
                                                    errorFieldList[index]?.shipperConfig?.isInvalid
                                                }
                                                helperText={
                                                    errorFieldList[index]?.shipperConfig?.message
                                                }
                                                onChange={(event, newValue) =>
                                                    handleMacropointIdChange(event, index)
                                                }
                                            />
                                        </div>
                                    ) : null}

                                    {!isMacropointProvider() ? (
                                        <div className="col-sm-1 align-self-center">
                                            <IconButton onClick={() => handleRemoveShipper(index)}>
                                                <i className={cs('fas fa-trash', css.iconButton)} />
                                            </IconButton>
                                        </div>
                                    ) : null}
                                </div>
                            );
                        })}
                    </div>
                    {!isMacropointProvider() ? (
                        <div className="row">
                            <div className="col-sm-12 text-right">
                                <div>
                                    <span
                                        id="add-more"
                                        className={css.customTextButton}
                                        onClick={() => createNewShipper()}
                                    >
                                        +Add More
                                    </span>
                                </div>
                            </div>
                        </div>
                    ) : null}

                    <div className={cs('row justify-content-end', css.actionButton)}>
                        <div className="col-sm-auto">
                            <MuiThemeProvider theme={PRIMARY_BUTTON_DEFAULT_NEGATIVE_THEME}>
                                <Button id="cancel" onClick={() => handleClose()}>
                                    CANCEL
                                </Button>
                            </MuiThemeProvider>
                            <MuiThemeProvider theme={PRIMARY_BUTTON_DEFAULT_POSITIVE_THEME}>
                                <Button
                                    id="add"
                                    disabled={disableSave()}
                                    onClick={() => saveAgreementRequest()}
                                >
                                    ADD
                                </Button>
                            </MuiThemeProvider>
                        </div>
                    </div>
                </Paper>
            </Modal>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        newShipperAgreement: state.agreement.newShipperAgreement,
        agreements: state.agreement.agreements,
        editedAgreements: state.agreement.editedAgreements,
        dataSource: state.connection.dataSource,
        sidebarResource: state.header.sidebarResource,
        identifiers: state.agreement.identifiers,
        selectedDataSource: state.agreement.selectedDataSource,
        session: state.session.sessionValue,
        selectedConnection: state.agreement.selectedConnection,
        shipperConfigObj: state.carrierConfig.shipperConfigObj,
        selectedProvider: state.agreement.selectedProvider
    };
};

export default connect(mapStateToProps, {
    clearShipmentIdentifiers,
    getShipmentIdentifiers,
    sendSelectedDataSource,
    addNewShipper,
    saveShipperConfig
})(withStyles(styles)(AddShipper));
